import { leftMetrics, parseOdds } from "./excelHelpers";

const byOr = (a, b) => (a ?? Infinity) - (b ?? Infinity);

// Strong Contenders, Long Shot Plays for the leg-1 race. Odds = live, ML fallback.
export const raceGlance = (rows) => {
  const m = leftMetrics(rows);
  const horses = rows
    .map((r, i) => ({
      post: Number(r.S),
      odds: m[i].odds,
      ml: parseOdds(r.ML),
      ratio: m[i].ratio,
      oddsText: parseOdds(r.LIVE) != null ? String(r.LIVE) : String(r.ML ?? ""),
      isMl: parseOdds(r.LIVE) == null,
      ok: m[i].iq !== null,
    }))
    .filter((h) => h.ok);
  const hasDdpo = horses.some((h) => h.ratio !== null);
  const sorted = [...horses].sort((a, b) =>
    hasDdpo ? byOr(a.ratio, b.ratio) || byOr(a.ml, b.ml) : a.odds - b.odds || byOr(a.ml, b.ml)
  );
  const strong = [...sorted.filter((h) => h.odds <= 3), ...sorted.filter((h) => h.odds > 3)]
    .slice(0, 2)
    .map((h) => ({ ...h, filler: h.odds > 3 }));
  const top3 = hasDdpo ? sorted.filter((h) => h.ratio !== null).slice(0, 3) : [];
  const longShots = top3.filter((h) => h.odds >= 5 && h.odds <= 12);
  return { strong, longShots, hasDdpo, byPost: new Map(horses.map((h) => [h.post, h])) };
};
